function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  Object.defineProperty(subClass, "prototype", {
    value: Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    }),
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import MultiPicker from "rmc-picker/es/MultiPicker";
import Picker from "rmc-picker/es/Picker";
import defaultLocale from './locale/en_US';

function getDaysInMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
}

function pad(n) {
  return n < 10 ? "0".concat(n) : n + '';
}

function cloneDate(date) {
  return new Date(+date);
}

function setMonth(date, month) {
  date.setDate(Math.min(date.getDate(), getDaysInMonth(new Date(date.getFullYear(), month))));
  date.setMonth(month);
}

var DATETIME = 'datetime';
var DATE = 'date';
var TIME = 'time';
var MONTH = 'month';
var YEAR = 'year';
var ONE_DAY = 24 * 60 * 60 * 1000;

var DatePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  var _super = _createSuper(DatePicker);

  function DatePicker() {
    var _this;

    _classCallCheck(this, DatePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      date: _this.props.date || _this.props.defaultDate
    };
    _this.defaultMinDate = void 0;
    _this.defaultMaxDate = void 0;

    _this.getNewDate = function (values, index) {
      var value = parseInt(values[index], 10);
      var props = _this.props;
      var mode = props.mode,
          useSeconds = props.useSeconds;
      var newValue = cloneDate(_this.getDate());

      if (mode === DATETIME || mode === DATE || mode === YEAR || mode === MONTH) {
        switch (index) {
          case 0:
            newValue.setFullYear(value);
            break;

          case 1:
            // Note: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setMonth
            // e.g. from 2017-03-31 to 2017-02-28
            setMonth(newValue, value);
            break;

          case 2:
            newValue.setDate(value);
            break;

          case 3:
            _this.setHours(newValue, value);

            break;

          case 4:
            newValue.setMinutes(value);
            break;

          case 5:
            useSeconds ? newValue.setSeconds(value) : _this.setAmPm(newValue, value);
            break;

          case 6:
            _this.setAmPm(newValue, value);

            break;

          default:
            break;
        }
      } else if (mode === TIME) {
        switch (index) {
          case 0:
            _this.setHours(newValue, value);

            break;

          case 1:
            newValue.setMinutes(value);
            break;

          case 2:
            useSeconds ? newValue.setSeconds(value) : _this.setAmPm(newValue, value);
            break;

          case 3:
            _this.setAmPm(newValue, value);

            break;

          default:
            break;
        }
      }

      return _this.clipDate(newValue);
    };

    _this.onValueChange = function (values, index) {
      var props = _this.props;

      var newValue = _this.getNewDate(values, index);

      if (!('date' in props)) {
        _this.setState({
          date: newValue
        });
      }

      if (props.onDateChange) {
        props.onDateChange(newValue);
      }

      if (props.onValueChange) {
        props.onValueChange(values, index);
      }
    };

    _this.onScrollChange = function (values, index) {
      var props = _this.props;

      if (props.onScrollChange) {
        var newValue = _this.getNewDate(values, index);

        props.onScrollChange(newValue, values, index);
      }
    };

    return _this;
  }

  _createClass(DatePicker, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if ('date' in nextProps) {
        this.setState({
          date: nextProps.date || nextProps.defaultDate
        });
      }
    }
  }, {
    key: "setHours",
    value: function setHours(date, hour) {
      if (this.props.use12Hours) {
        var dh = date.getHours();
        var nhour = hour;
        nhour = dh >= 12 ? hour + 12 : hour;
        nhour = nhour >= 24 ? 0 : nhour; // Make sure no more than one day

        date.setHours(nhour);
      } else {
        date.setHours(hour);
      }
    }
  }, {
    key: "setAmPm",
    value: function setAmPm(date, index) {
      if (index === 0) {
        date.setTime(+date - ONE_DAY / 2);
      } else {
        date.setTime(+date + ONE_DAY / 2);
      }
    }
  }, {
    key: "getDefaultMinDate",
    value: function getDefaultMinDate() {
      if (!this.defaultMinDate) {
        this.defaultMinDate = new Date(2000, 1, 1, 0, 0, 0);
      }

      return this.defaultMinDate;
    }
  }, {
    key: "getDefaultMaxDate",
    value: function getDefaultMaxDate() {
      if (!this.defaultMaxDate) {
        this.defaultMaxDate = new Date(2030, 1, 1, 23, 59, 59);
      }

      return this.defaultMaxDate;
    }
  }, {
    key: "getDate",
    value: function getDate() {
      return this.clipDate(this.state.date || this.getDefaultMinDate());
    } // used by rmc-picker/lib/PopupMixin.js

  }, {
    key: "getValue",
    value: function getValue() {
      return this.getDate();
    }
  }, {
    key: "getMinYear",
    value: function getMinYear() {
      return this.getMinDate().getFullYear();
    }
  }, {
    key: "getMaxYear",
    value: function getMaxYear() {
      return this.getMaxDate().getFullYear();
    }
  }, {
    key: "getMinMonth",
    value: function getMinMonth() {
      return this.getMinDate().getMonth();
    }
  }, {
    key: "getMaxMonth",
    value: function getMaxMonth() {
      return this.getMaxDate().getMonth();
    }
  }, {
    key: "getMinDay",
    value: function getMinDay() {
      return this.getMinDate().getDate();
    }
  }, {
    key: "getMaxDay",
    value: function getMaxDay() {
      return this.getMaxDate().getDate();
    }
  }, {
    key: "getMinHour",
    value: function getMinHour() {
      return this.getMinDate().getHours();
    }
  }, {
    key: "getMaxHour",
    value: function getMaxHour() {
      return this.getMaxDate().getHours();
    }
  }, {
    key: "getMinMinute",
    value: function getMinMinute() {
      return this.getMinDate().getMinutes();
    }
  }, {
    key: "getMaxMinute",
    value: function getMaxMinute() {
      return this.getMaxDate().getMinutes();
    }
  }, {
    key: "getMinSecond",
    value: function getMinSecond() {
      return this.getMinDate().getSeconds();
    }
  }, {
    key: "getMaxSecond",
    value: function getMaxSecond() {
      return this.getMaxDate().getSeconds();
    }
  }, {
    key: "getMinDate",
    value: function getMinDate() {
      return this.props.minDate || this.getDefaultMinDate();
    }
  }, {
    key: "getMaxDate",
    value: function getMaxDate() {
      return this.props.maxDate || this.getDefaultMaxDate();
    }
  }, {
    key: "getDateData",
    value: function getDateData() {
      var _this$props = this.props,
          locale = _this$props.locale,
          formatMonth = _this$props.formatMonth,
          formatDay = _this$props.formatDay,
          mode = _this$props.mode;
      var date = this.getDate();
      var selYear = date.getFullYear();
      var selMonth = date.getMonth();
      var minDateYear = this.getMinYear();
      var maxDateYear = this.getMaxYear();
      var minDateMonth = this.getMinMonth();
      var maxDateMonth = this.getMaxMonth();
      var minDateDay = this.getMinDay();
      var maxDateDay = this.getMaxDay();
      var years = [];

      for (var i = minDateYear; i <= maxDateYear; i++) {
        years.push({
          value: i + '',
          label: i + locale.year + ''
        });
      }

      var yearCol = {
        key: 'year',
        props: {
          children: years
        }
      };

      if (mode === YEAR) {
        return [yearCol];
      }

      var months = [];
      var minMonth = 0;
      var maxMonth = 11;

      if (minDateYear === selYear) {
        minMonth = minDateMonth;
      }

      if (maxDateYear === selYear) {
        maxMonth = maxDateMonth;
      }

      for (var _i = minMonth; _i <= maxMonth; _i++) {
        var label = formatMonth ? formatMonth(_i, date) : _i + 1 + locale.month + '';
        months.push({
          value: _i + '',
          label: label
        });
      }

      var monthCol = {
        key: 'month',
        props: {
          children: months
        }
      };

      if (mode === MONTH) {
        return [yearCol, monthCol];
      }

      var days = [];
      var minDay = 1;
      var maxDay = getDaysInMonth(date);

      if (minDateYear === selYear && minDateMonth === selMonth) {
        minDay = minDateDay;
      }

      if (maxDateYear === selYear && maxDateMonth === selMonth) {
        maxDay = maxDateDay;
      }

      for (var _i2 = minDay; _i2 <= maxDay; _i2++) {
        var _label = formatDay ? formatDay(_i2, date) : _i2 + locale.day + '';

        days.push({
          value: _i2 + '',
          label: _label
        });
      }

      return [yearCol, monthCol, {
        key: 'day',
        props: {
          children: days
        }
      }];
    }
  }, {
    key: "getDisplayHour",
    value: function getDisplayHour(rawHour) {
      // 12 hour am (midnight 00:00) -> 12 hour pm (noon 12:00) -> 12 hour am (midnight 00:00)
      if (this.props.use12Hours) {
        if (rawHour === 0) {
          rawHour = 12;
        }

        if (rawHour > 12) {
          rawHour -= 12;
        }

        return rawHour;
      }

      return rawHour;
    }
  }, {
    key: "getTimeData",
    value: function getTimeData(date) {
      var _this$props2 = this.props,
          _this$props2$minHour = _this$props2.minHour,
          minHour = _this$props2$minHour === void 0 ? 0 : _this$props2$minHour,
          _this$props2$maxHour = _this$props2.maxHour,
          maxHour = _this$props2$maxHour === void 0 ? 23 : _this$props2$maxHour,
          _this$props2$minMinut = _this$props2.minMinute,
          minMinute = _this$props2$minMinut === void 0 ? 0 : _this$props2$minMinut,
          _this$props2$maxMinut = _this$props2.maxMinute,
          maxMinute = _this$props2$maxMinut === void 0 ? 59 : _this$props2$maxMinut,
          _this$props2$minSecon = _this$props2.minSecond,
          minSecond = _this$props2$minSecon === void 0 ? 0 : _this$props2$minSecon,
          _this$props2$maxSecon = _this$props2.maxSecond,
          maxSecond = _this$props2$maxSecon === void 0 ? 59 : _this$props2$maxSecon;
      var _this$props3 = this.props,
          mode = _this$props3.mode,
          locale = _this$props3.locale,
          _this$props3$minuteSt = _this$props3.minuteStep,
          minuteStep = _this$props3$minuteSt === void 0 ? 1 : _this$props3$minuteSt,
          use12Hours = _this$props3.use12Hours,
          _this$props3$secondSt = _this$props3.secondStep,
          secondStep = _this$props3$secondSt === void 0 ? 1 : _this$props3$secondSt,
          useSeconds = _this$props3.useSeconds;
      var minDateSecond = this.getMinSecond();
      var maxDateSecond = this.getMaxSecond();
      var minDateMinute = this.getMinMinute();
      var maxDateMinute = this.getMaxMinute();
      var minDateHour = this.getMinHour();
      var maxDateHour = this.getMaxHour();
      var hour = date.getHours();
      var minute = date.getMinutes();

      if (mode === DATETIME) {
        var year = date.getFullYear();
        var month = date.getMonth();
        var day = date.getDate();
        var minDateYear = this.getMinYear();
        var maxDateYear = this.getMaxYear();
        var minDateMonth = this.getMinMonth();
        var maxDateMonth = this.getMaxMonth();
        var minDateDay = this.getMinDay();
        var maxDateDay = this.getMaxDay();

        if (minDateYear === year && minDateMonth === month && minDateDay === day) {
          minHour = minDateHour;

          if (minDateHour === hour) {
            minMinute = minDateMinute;

            if (minute === minDateMinute) {
              minSecond = minDateSecond;
            }
          }
        }

        if (maxDateYear === year && maxDateMonth === month && maxDateDay === day) {
          maxHour = maxDateHour;

          if (maxDateHour === hour) {
            maxMinute = maxDateMinute;

            if (minute === maxDateMinute) {
              maxSecond = maxDateSecond;
            }
          }
        }
      } else {
        minHour = minDateHour;

        if (minDateHour === hour) {
          minMinute = minDateMinute;

          if (minute === minDateMinute) {
            minSecond = minDateSecond;
          }
        }

        maxHour = maxDateHour;

        if (maxDateHour === hour) {
          maxMinute = maxDateMinute;

          if (minute === maxDateMinute) {
            maxSecond = maxDateSecond;
          }
        }
      }

      var hours = [];

      if (minHour === 0 && maxHour === 0 || minHour !== 0 && maxHour !== 0) {
        minHour = this.getDisplayHour(minHour);
      } else if (minHour === 0 && use12Hours) {
        minHour = 1;
        hours.push({
          value: '0',
          label: locale.hour ? '12' + locale.hour : '12'
        });
      }

      maxHour = this.getDisplayHour(maxHour);

      for (var i = minHour; i <= maxHour; i++) {
        hours.push({
          value: i + '',
          label: locale.hour ? i + locale.hour + '' : pad(i)
        });
      }

      var minutes = [];
      var selMinute = date.getMinutes();

      for (var _i3 = minMinute; _i3 <= maxMinute; _i3 += minuteStep) {
        minutes.push({
          value: _i3 + '',
          label: locale.minute ? _i3 + locale.minute + '' : pad(_i3)
        });

        if (selMinute > _i3 && selMinute < _i3 + minuteStep) {
          minutes.push({
            value: selMinute + '',
            label: locale.minute ? selMinute + locale.minute + '' : pad(selMinute)
          });
        }
      }

      var seconds = [];
      var selSecond = date.getSeconds();

      for (var _i4 = minSecond; _i4 <= maxSecond; _i4 += secondStep) {
        seconds.push({
          value: _i4 + '',
          label: locale.second ? _i4 + locale.second + '' : pad(_i4)
        });

        if (selSecond > _i4 && selSecond < _i4 + secondStep) {
          seconds.push({
            value: selSecond + '',
            label: locale.second ? selSecond + locale.second + '' : pad(selSecond)
          });
        }
      }

      var cols = [{
        key: 'hours',
        props: {
          children: hours
        }
      }, {
        key: 'minutes',
        props: {
          children: minutes
        }
      }];

      if (useSeconds) {
        cols.push({
          key: 'second',
          props: {
            children: seconds
          }
        });
      }

      cols = cols.concat(use12Hours ? [{
        key: 'ampm',
        props: {
          children: [{
            value: '0',
            label: locale.am
          }, {
            value: '1',
            label: locale.pm
          }]
        }
      }] : []);
      return {
        cols: cols,
        selMinute: selMinute,
        selSecond: selSecond
      };
    }
  }, {
    key: "clipDate",
    value: function clipDate(date) {
      var _this$props4 = this.props,
          mode = _this$props4.mode,
          useSeconds = _this$props4.useSeconds;
      var minDate = this.getMinDate();
      var maxDate = this.getMaxDate();

      if (mode === DATETIME) {
        if (date < minDate) {
          return cloneDate(minDate);
        }

        if (date > maxDate) {
          return cloneDate(maxDate);
        }
      } else if (mode === DATE || mode === YEAR || mode === MONTH) {
        // compare-two-dates: https://stackoverflow.com/a/14629978/2190503
        if (+date + ONE_DAY <= minDate) {
          return cloneDate(minDate);
        }

        if (date >= +maxDate + ONE_DAY) {
          return cloneDate(maxDate);
        }
      } else if (mode === TIME && _typeof(date) === 'object') {
        var maxHour = maxDate.getHours();
        var maxMinutes = maxDate.getMinutes();
        var maxSeconds = maxDate.getSeconds();
        var minHour = minDate.getHours();
        var minMinutes = minDate.getMinutes();
        var minSeconds = minDate.getSeconds();
        var hour = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();

        if (hour < minHour || hour === minHour && minutes < minMinutes || useSeconds && hour === minHour && minutes === minMinutes && seconds < minSeconds) {
          return cloneDate(minDate);
        }

        if (hour > maxHour || hour === maxHour && minutes > maxMinutes || useSeconds && hour === maxHour && minutes === minMinutes && seconds > maxSeconds) {
          return cloneDate(maxDate);
        }
      }

      return typeof date === 'number' ? new Date(date) : date;
    }
  }, {
    key: "getValueCols",
    value: function getValueCols() {
      var _this$props5 = this.props,
          mode = _this$props5.mode,
          use12Hours = _this$props5.use12Hours,
          useSeconds = _this$props5.useSeconds;
      var date = this.getDate();
      var cols = [];
      var value = [];

      if (mode === YEAR) {
        return {
          cols: this.getDateData(),
          value: [date.getFullYear() + '']
        };
      }

      if (mode === MONTH) {
        return {
          cols: this.getDateData(),
          value: [date.getFullYear() + '', date.getMonth() + '']
        };
      }

      if (mode === DATETIME || mode === DATE) {
        cols = this.getDateData();
        value = [date.getFullYear() + '', date.getMonth() + '', date.getDate() + ''];
      }

      if (mode === DATETIME || mode === TIME) {
        var time = this.getTimeData(date);
        cols = cols.concat(time.cols);
        var hour = date.getHours();
        var dtValue = [hour + '', time.selMinute + ''];
        var nhour = hour;

        if (use12Hours) {
          nhour = hour > 12 ? hour - 12 : hour;
          dtValue = [nhour + '', time.selMinute + '', (hour >= 12 ? 1 : 0) + ''];
        }

        if (useSeconds) {
          dtValue.splice(2, 0, time.selSecond + '');
        }

        value = value.concat(dtValue);
      }

      return {
        value: value,
        cols: cols
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getValueCols = this.getValueCols(),
          value = _this$getValueCols.value,
          cols = _this$getValueCols.cols;

      var _this$props6 = this.props,
          disabled = _this$props6.disabled,
          pickerPrefixCls = _this$props6.pickerPrefixCls,
          prefixCls = _this$props6.prefixCls,
          rootNativeProps = _this$props6.rootNativeProps,
          className = _this$props6.className,
          style = _this$props6.style,
          itemStyle = _this$props6.itemStyle;

      var multiStyle = _objectSpread({
        flexDirection: 'row',
        alignItems: 'center'
      }, style);

      return /*#__PURE__*/React.createElement(MultiPicker, {
        style: multiStyle,
        rootNativeProps: rootNativeProps,
        className: className,
        prefixCls: prefixCls,
        selectedValue: value,
        onValueChange: this.onValueChange,
        onScrollChange: this.onScrollChange
      }, cols.map(function (p) {
        return /*#__PURE__*/React.createElement(Picker, {
          style: {
            flex: p.key === 'year' ? 1.5 : 1
          },
          key: p.key,
          disabled: disabled,
          prefixCls: pickerPrefixCls,
          itemStyle: itemStyle
        }, p.props.children.map(function (item) {
          return /*#__PURE__*/React.createElement(Picker.Item, {
            key: item.value,
            value: item.value
          }, item.label);
        }));
      }));
    }
  }]);

  return DatePicker;
}(React.Component);

DatePicker.defaultProps = {
  prefixCls: 'rmc-date-picker',
  pickerPrefixCls: 'rmc-picker',
  locale: defaultLocale,
  mode: DATE,
  disabled: false,
  minuteStep: 1,
  secondStep: 1,
  onDateChange: function onDateChange() {},
  use12Hours: false,
  useSeconds: false
};
export default DatePicker;